import { FileText, X } from 'lucide-react';
import type { TaxInvoiceTranslations } from './types';

interface TaxInvoiceHeaderProps {
  t: TaxInvoiceTranslations;
  onClose: () => void;
  isGenerating: boolean;
}

export function TaxInvoiceHeader({ t, onClose, isGenerating }: TaxInvoiceHeaderProps) {
  return (
    <div className="p-6 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center">
            <FileText className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-900">{t.taxInvoice}</h2>
            <p className="text-sm text-gray-600">{t.cfdiInvoice}</p>
          </div>
        </div>
        <button
          onClick={onClose}
          className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center"
          disabled={isGenerating}
        >
          <X className="w-4 h-4 text-gray-400" />
        </button>
      </div>
    </div>
  );
}
